import React, { useEffect, useState, useRef } from 'react'
import styles from './styles.module.scss'
import Popup from 'reactjs-popup'
import { useTranslation } from 'react-i18next'
import IconButton from 'srcReact/components/common2/IconButton'
import Avatar from 'srcReact/components/common2/Avatar'
import RichTextEditor from 'srcReact/components/common2/RichTextEditor'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import Label from 'srcReact/components/common2/Label'
import Button from 'srcReact/components/common2/Button'
import { commonActions } from 'srcReact/components'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'srcReact/helpers/validator'
import Spinner from 'srcReact/components/common2/Spinner'
import SuccessMessage from 'srcReact/components/common2/SuccessMessage'

function ModalWithPost({
  objectType,
  objectId,
  isOpen,
  users,
  title,
  subTitle,
  defaultMessage,
  isMessageRequied,
  handleCancel,
  handleConfirm,
  primaryBtnText,
  secondaryBtnText,
  showTag,
  labelText,
  closeOnDocumentClick,
  customContentStyle,
  loading,
  errorMessage,
  successMessage,
  doCleaning,
  ...rest
}) {
  console.log('users::', users)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const editorRef = useRef('postFromModal')
  const [message, setMessage] = useState({
    name: 'message',
    value: defaultMessage,
    hasError: false,
    errorMessage: '',
    isRequired: isMessageRequied
  })

  const {
    common: { tagUsersList }
  } = useSelector((state) => state)

  const contentStyle = {
    borderRadius: '0.625rem',
    padding: '1.5rem 1rem 2.5rem',
    background: '#fafaff',
    maxHeight: '95vh',
    overflow: 'auto',
    boxShadow: '0 2px 6px 1px rgba(0, 0, 0, 0.1)',
    position: 'relative',
    pointerEvents: 'none',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }
  const contentWidth = {
    width: '95%',
    maxWidth: '40rem'
  }
  const finalContentWidth = customContentStyle ? customContentStyle : contentWidth
  useEffect(() => {
    dispatch(commonActions.getTagUsers(objectType, objectId))
    return () => {
      document.body.style.overflow = 'unset'
      if (doCleaning) {
        doCleaning()
      }
    }
  }, [])

  const handleChange = (currentContent) => {
    setMessage({
      ...message.value,
      value: currentContent,
      hasError: false,
      errorMessage: ''
    })
  }
  const handleErrorFromInputArea = (error) => {
    if (error) {
      setMessage({
        ...message,
        hasError: true,
        errorMessage: error
      })
    } else {
      setMessage({
        ...message,
        hasError: false,
        errorMessage: ''
      })
    }
  }

  const handleSubmit = () => {
    if (isMessageRequied && isEmpty(message.value)) {
      setMessage({
        ...message,
        hasError: true,
        errorMessage: t('error.required', { field: t(`formlabel.message`) })
      })
      return
    }
    handleConfirm(message.value)
  }

  return (
    <Popup
      lockScroll
      className={`${styles.modalContainer}`}
      contentStyle={{ ...contentStyle, ...finalContentWidth }}
      open={isOpen}
      onClose={handleCancel}
      closeOnDocumentClick={closeOnDocumentClick}
      {...rest}>
      <div className={styles.modalWrapper}>
        <header className={`${styles.header}`}>
          <IconButton
            iconName='close24'
            iconSize='large24'
            onClick={handleCancel}
            className={`${styles.closeButton}`}
            aria-label={t('global.alert_close')}
          />
        </header>

        {title && <h1 className={styles.title}>{title}</h1>}
        {subTitle && <h2 className={styles.subTitle} dangerouslySetInnerHTML={{ __html: subTitle }} />}

        <div className={styles.pictures}>
          {users?.length > 0 &&
            users.map((user) => (
              <Avatar
                userId={user.id || user.user_info.id}
                firstname={user.firstname || user.user_info.firstname}
                lastname={user.lastname || user.user_info.lastname}
                profilePicture={
                  user.profile_picture_data?.profile_picture || user.user_info.profile_picture_data?.profile_picture
                }
                imgWrapperSize='small52'
                mimeType={user.profile_picture_data?.mime_type || user.user_info.profile_picture_data?.mime_type}
                originalTag={
                  user.profile_picture_data?.original_tag || user.user_info.profile_picture_data?.original_tag
                }
                isOriginal={user.profile_picture_data?.is_original || user.user_info.profile_picture_data?.is_original}
                showUserName={true}
                withExpertiseGroup={user.user_info.with_expertise_group}
              />
            ))}
        </div>
        <div className={styles.postContainer}>
          <Label>{labelText}</Label>
          <RichTextEditor
            value={message.value}
            showToolbar={false}
            showTextFormatter={false}
            showEmojiPicker={false}
            showFilePicker={false}
            handleChange={handleChange}
            containerCSS={styles.richTextAreaWrapper}
            handleInputError={handleErrorFromInputArea}
            editorRef={editorRef}
            editorId={`celebratePost`}
            errorMessageRequired={t('error.required', { field: t(`formlabel.${message.name}`) })}
            keepFormatOnPopulate={true}
            activeUsers={tagUsersList}
            mentionMenuOrientation='bottom'
          />
          {message.hasError && <ErrorMessage text={message.errorMessage} className={styles.error} />}
        </div>
      </div>
      <div className={styles.buttons}>
        <Button text={secondaryBtnText} style='secondary' handleClick={handleCancel} />
        <Button text={primaryBtnText} handleClick={handleSubmit} />
      </div>
      <div className={styles.status}>
        {loading && <Spinner />}
        {errorMessage && <ErrorMessage text={errorMessage} />}
        {successMessage && <SuccessMessage text={successMessage} />}
      </div>
    </Popup>
  )
}

export default ModalWithPost
